import { makeStyles } from '@material-ui/core/styles';
import { variables } from 'components/Theme/';

export const useStyles = makeStyles((theme) => ({
  subTitle: {
    fontSize: 13,
    color: '#586375',
    fontStyle: 'italic',
  },
  elite: {
    width: '100%',
  },
  eliteHead: {
    background: '#192542',
    borderRadius: '4px 4px 0 0',
    padding: '40px 20px',
    color: '#fff',
    '&.--affiliate': {
      borderRadius: 0,
    },
  },
  eliteTitle: {
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
  '@keyframes animateBar': {
    '0%': {
      backgroundSize: 0,
      opacity: 0.5,
    },
    '100%': {
      opacity: 1,
      backgroundSize: '100%',
    },
  },

  '@keyframes showLevel': {
    '0%': {
      opacity: 0,
    },
    '100%': {
      opacity: 1,
    },
  },

  eliteSlide: {
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    position: 'relative',

    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },

    '&.--red': {
      '&:before': {
        backgroundImage: 'linear-gradient(90deg, #FFF 12%, #CC1C0B 18%, rgb(51, 51, 51) 42%, #333333 64%, rgb(51, 51, 51) 92%)',
      },
    },

    '&.--orange': {
      '&:before': {
        backgroundImage: 'linear-gradient(90deg, #FFF 12%, #CC1C0B 18%, #FF5E1F 59%, rgb(51, 51, 51) 64%, rgb(51, 51, 51) 92%)',
      },
    },

    '&.--green': {
      '&:before': {
        backgroundImage: 'linear-gradient(90deg, #FFF 12%, #CC1C0B 18%, #FF5E1F 59%, #007E38 63%, rgba(0,0,0,0.00) 92%)',
      },
    },

    '&.--black': {
      '&:before': {
        backgroundImage: 'linear-gradient(90deg, #FFF 12%, #CC1C0B 18%, #FF5E1F 59%, #007E38 63%, #333333 90%)',
      },
    },

    '&.--affiliate': {
      '&:before': {
        backgroundImage: 'linear-gradient(90deg, #0099ff 8%, rgb(51, 51, 51) 20%)',
      },
    },

    '&.--affiliate10': {
      '&:before': {
        backgroundImage: 'linear-gradient(90deg, #0099ff 0%, rgb(51, 51, 51) 25%, #333333 40%, rgb(51, 51, 51) 60%)',
      },
    },

    '&.--affiliate50': {
      '&:before': {
        backgroundImage: 'linear-gradient(90deg, #0099ff 0%, #0099ff 30%, #333333 40%, rgb(51, 51, 51) 60%)',
      },
    },

    '&.--affiliate100': {
      '&:before': {
        backgroundImage: 'linear-gradient(90deg, #0099ff 0%, #0099ff 30%, #0099ff 45%, #333333 65%, rgb(51, 51, 51) 90%)',
      },
    },

    '&.--affiliate500': {
      '&:before': {
        backgroundImage: 'linear-gradient(90deg, #0099ff 0%, #0099ff 30%, #0099ff 45%, #0099ff 75%, rgb(51, 51, 51) 90%)',
      },
    },

    '&.--affiliateHigh': {
      '&:before': {
        backgroundImage: 'linear-gradient(90deg, #0099ff 0%, #0099ff 30%, #0099ff 75%, #e6e600 85%, #e6e600 100%)',
      },
    },

    '&:before': {
      content: '""',
      width: '100%',
      height: 9,
      backgroundColor: '#333',
      backgroundRepeat: 'no-repeat',
      backgroundImage: 'linear-gradient(90deg, #FFF 8%, rgb(51, 51, 51) 20%)',
      borderRadius: 20,
      top: 'calc((100% / 2) - 4px)',
      left: 0,
      position: 'absolute',
      boxShadow: '0 0 5px -2px #000',
      animation: 'animateBar 1.5s linear',
    },
  },

  eliteSlideItem: {
    padding: '0 20px',
    textAlign: 'center',
    position: 'relative',

    '&.--active': {
      animation: 'showLevel 1.5s linear',

      '& label': {
        display: 'block',
        fontWeight: 500,
        marginBottom: 32,
        color: '#fff',
      },

      '& span': {
        color: '#fff',
      },

      '&:before': {
        width: 16,
        height: 16,
        borderRadius: '50%',
        background: 'white',
        position: 'absolute',
        content: '""',
        top: 'calc((100% / 2) - 8px)',
        left: 'calc((100% / 2) - 8px)',
        zIndex: 3,
        animation: 'showLevel 1.5s linear',
      },
    },

    '&.--visible': {
      animation: 'showLevel 1.5s linear',

      '& label': {
        display: 'block',
        fontWeight: 500,
        marginBottom: 32,
        color: '#fff',
      },

      '& span': {
        color: '#fff',
      },
    },

    '& label': {
      display: 'block',
      fontWeight: 500,
      marginBottom: 32,
      color: '#edf1f5',
    },

    '& span': {
      fontSize: 15,
      color: '#edf1f5',
    },
  },

  // Premium
  eliteSlidePremium: {
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    position: 'relative',

    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },

    '&:before': {
      content: '""',
      width: '100%',
      height: 9,
      backgroundColor: '#333',
      backgroundRepeat: 'no-repeat',
      borderRadius: 20,
      top: 'calc((100% / 2) - 4px)',
      left: 0,
      position: 'absolute',
      boxShadow: '0 0 5px -2px #000',
      animation: 'animateBar 1.5s linear',
      backgroundImage: 'linear-gradient(90deg, #222 78%, #DFBF74 100%)',
    },

    '&.--golden:before': {
      backgroundImage: 'linear-gradient(90deg, #DFBF74 78%, #AB7120 100%)',
    },
  },

  eliteSlideItemPremium: {
    padding: '0 12px',
    textAlign: 'center',
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'space-around',
    justifyContent: 'space-around',

    '&.--active': {
      animation: 'showLevel 1.5s linear',

      '& label': {
        display: 'block',
        fontWeight: 500,
        marginBottom: 54,
        color: '#fff',
      },

      '& span': {
        color: '#fff',
      },

      '&:before': {
        width: 16,
        height: 16,
        borderRadius: '50%',
        background: 'white',
        position: 'absolute',
        content: '""',
        top: 'calc((100% / 2) - 8px)',
        left: 'calc((100% / 2) - 8px)',
        zIndex: 3,
        animation: 'showLevel 1.5s linear',
      },
    },

    '&.--visible': {
      animation: 'showLevel 1.5s linear',

      '& label': {
        display: 'block',
        fontWeight: 500,
        marginBottom: 54,
        color: '#fff',
      },

      '& span': {
        color: '#fff',
      },
    },

    '& label': {
      display: 'block',
      fontWeight: 500,
      marginBottom: 54,
      color: '#555',
    },

    '& span': {
      fontSize: 14,
      color: '#555',
    },
  },

  // badges
  badgesContainer: {
    width: '100%',
    background: 'white',
    padding: 20,
    borderRadius: '0 0 4px 4px',
  },

  badges: {
    width: '100%',
    display: 'flex',
    alignItems: 'flex-start',
    flexWrap: 'wrap',
  },

  badgeItem: {
    width: 'calc((100% / 5) - 32px)',
    display: 'inline-block',
    margin: '10px 16px',
    textAlign: 'center',
    fontSize: 14,
    opacity: 0.3,
    fontWeight: 400,
    color: variables.palette.primary.dark,

    [theme.breakpoints.down('md')]: {
      width: 'calc((100% / 4) - 32px)',
    },

    [theme.breakpoints.down('sm')]: {
      width: 'calc((100% / 3) - 32px)',
    },

    [theme.breakpoints.down('xs')]: {
      width: 'calc((100% / 2) - 32px)',
    },

    '&.--active': {
      opacity: 1,

      '& img, svg': {
        filter: 'grayscale(0%)',
      },
    },

    '& img, svg': {
      maxWidth: '100%',
      display: 'block',
      filter: 'grayscale(100%)',
    },

    '& label': {
      marginTop: 12,
      display: 'block',
    },

    '& .secondary-text': {
      color: '#888888',
      marginTop: 2,
      fontWeight: 500,
    },
  },

  // profile
  profile: {
    padding: 20,
    boxShadow: variables.shadows[1],
    position: 'relative',
    top: -294,
    background: 'white',
    borderRadius: 4,
    width: '100%',

    [theme.breakpoints.down('sm')]: {
      top: -165,
      order: 1,
    },
  },

  profileAvatar: {
    width: 160,
    position: 'relative',
    top: -80,
    textAlign: 'center',
    margin: '0 auto',
    marginBottom: -60,

    [theme.breakpoints.down('sm')]: {
      top: -70,
      width: 120,
    },
  },

  avatar: {
    width: 160,
    height: 160,
    border: '5px solid white',
    margin: '0 auto',
    display: 'block',
    borderRadius: '100%',
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
    background: variables.palette.grey[300],

    [theme.breakpoints.down('sm')]: {
      width: 120,
      height: 120,
    },
  },

  avatarBadge: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: 42,
    height: 42,
    background: 'white',
    border: '3px solid white',
    borderRadius: '100%',

    '& img': {
      maxWidth: '100%',
    },
  },

  profileText: {
    width: '100%',
    textAlign: 'center',

    '& label': {
      display: 'block',
      fontSize: 16,
      marginBottom: 4,
    },

    '& span': {
      display: 'block',
      fontWeight: 600,
      fontSize: 30,
      letterSpacing: -1,

      [theme.breakpoints.down('sm')]: {
        fontSize: 25,
      },
    },
  },

  order2Mobile: {
    [theme.breakpoints.down('sm')]: {
      order: 2,
    },
  },

  order1Mobile: {
    [theme.breakpoints.down('sm')]: {
      order: 1,
    },
  },
  knowMore: {},
}));
